import  * as dashboardActions from '../../../pillar/dashboard/store/actions/';
import { IDataWarehouseState } from '../states/IDataWarehouseState';
import { DataSetRootEntityModel } from '../../models/DataSetRootEntityModel';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const initialState: IDataWarehouseState = {
  dataSets: [],
  dataSetsLoading: false,
  dataSetsTotalCount: 0
}

export function dataWarehouseReducer(state = initialState, action: dashboardActions.Actions<DataSetRootEntityModel>): IDataWarehouseState {
  switch (action.type) {
    case dashboardActions.getQueryListType(ModuleConfiguration.moduleName, DataSetRootEntityModel):
        return {
          ...state,
          dataSetsLoading: true
        };
    case dashboardActions.querySuccessType(ModuleConfiguration.moduleName, DataSetRootEntityModel):
        const querySuccessAction = (action as dashboardActions.QuerySuccessAction<DataSetRootEntityModel>);
        return {
          ...state,
          dataSets: querySuccessAction.payload.items,
          dataSetsLoading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/reducers/datawarehouse.reducer.ts